/** Single-string OTP resend label for web (ENG-524). */
export function formatOtpResendCountdownLabel(timeRemainingSeconds: number): string {
  return `Resend code in 00:${String(timeRemainingSeconds).padStart(2, "0")}`
}
